import React, { useEffect, useState } from "react";
import { Navigate, Route, RouterProvider, Routes, useRoutes } from "react-router-dom";
import { AppRoutes } from "./helper/appRoutes";
import { AddCustomerInvoice } from "./components/AddEdit/AddCustomerInvoice";
import { AddEditCustomerPaymentLinks } from "./components/AddEdit/AddEditCustomerPaymentLink";
import { AddEditPartners } from "./components/AddEdit/AddEditPartners";
import { AddEditStateStamps } from "./components/AddEdit/AddEditStateStamps";
import useAuth, { AuthProvider } from "./context/AuthProvider";
import { PrivateRoute } from "./context/ProtectedRoute";
import { TransactionDetails } from "./DetailPages/TransactionDetails";
import { MuiLicenseKey } from "./Constants";

import { ComingSoon } from "./Pages/ComingSoon";
import { CreateCustomerPolicy } from "./Pages/CreateCustomerPolicy";
import { CustomerInvoice } from "./Pages/CustomerInvoice";
import { CustomerPolicy } from "./Pages/CustomerPolicy";
import { CustomerPolicyDocumentData } from "./Pages/CustomerPolicyDocumentData";
import { Submissions } from "./Pages/Submissions";
import { FMFlagReview } from "./Pages/FMFlagReview";
import { InsuranceComapny } from "./Pages/InsuranceCompany";
import { LoginPage } from "./Pages/Login";
import { CreateNewSubmission } from "./Pages/NewSubmission";
import { Partners } from "./Pages/Partners";
import { PartnerUsers } from "./Pages/PartnerUsers";
import { Policies } from "./Pages/Policies";
import { Policy } from "./Pages/Policy";
import { PolicyFilingsSchedule } from "./Pages/PolicyFilingSchedule";
import { ReportModule } from "./Pages/ReportModule";
import { ResubmitCustomerPolicyDocs } from "./Pages/ResubmitCustomerPolicyDocs";


import { StatesZeroFilingRule } from "./Pages/StatesZeroFilingsRule";

import { TaxesAndFees } from "./Pages/TaxesAndFees";
import { TaxesAndFeesFilingSchedule } from "./Pages/TaxesAndFeesFilingSchedule";
import { MessageTemplatesAdmin } from "./Pages/MessageTemplatesAdmin";
import { Trainer } from "./Pages/Trainer";
import { Transaction } from "./Pages/Transaction";
import { TransactionFee } from "./Pages/TransactionFee";
import { TransactionFeePartner } from "./Pages/TransactionFeePartner";

import { Users } from "./Pages/Users";
// Logs component has been removed
import { PolicyDashboard } from "./Pages/PolicyDashboard";
import { DocumentCorrections } from "./Pages/DocumentCorrections";
import { AdminDashboard } from "./Pages/AdminDashboard";
import { ClientDashboard } from "./Pages/ClientDashboard";
import { CarrierManagement } from "./Pages/CarrierManagement";
import { SendClientPortalUpdate } from "./Pages/SendClientPortalUpdate";
import { PartnerFeesT } from "./Pages/PartnerFeesT";
import { ResubmitSingleDocumentNew } from "./Pages/ResubmitsingleDocumentNew";

// DocumentType has been removed
import { AddEditCASlaJsonData } from "./components/AddEdit/AddEditCASLaJsonData";
// UserMappingRequestLog has been removed
import { PageNotFound } from "./Pages/PageNotFound";

import { ResetPassword } from "./Pages/ResetPassword";
import { Thankyou } from "./Pages/ThankYouSuccessMsg";
// AddStateFlags has been removed
import { TaxScheduleByJurisdiction } from "./Pages/TaxScheduleByJurisdiction";
import { SubmissionData_SD } from "./Pages/SubmissionData_SD";
import { LateFilingForm } from "./Pages/LateFilingReason";
import { AddEditCarrierManageLineOfBussinessCheckBox } from "./components/AddEdit/AddEditCarrierManageLineOfBussinessCheckBox";
import { EmailReportModule } from "./Pages/EmailReportModule";
import { EmailReportModuleDetails } from "./Pages/EmailReportModuleDetails";
import { RightNav } from "./components/Nav/RightNav";
// LateFilingRequest
import type { RouteObject } from "react-router";
import Layout from "./components/Layout/Layout";
import CustomerLayout from "./components/Layout/CustomerLayout";
import "./App.css"
import { OpenTaxReport } from "./Pages/OpenTaxReport";
import { CustomerOpenTaxReport } from "./Pages/CustomerOpenTaxReport";
import { ReconciliationQueue } from "./Pages/ReconciliationQueue";
import { FilingReview } from "./Pages/FilingReview";
import { DiligentSearch } from "./Pages/DiligentSearch";
import { ClientBillingReport } from "./Pages/ClientBillingReport";
import { StateReportsBilling} from "./Pages/StateReportsBilling"
import { AddEditCustomerPolicyDetails } from "./components/AddEdit/AddEditCustomerPolicyDetails";
import { LicenseInfo } from "@mui/x-data-grid-pro";
import { StateLogins } from "./Pages/StateLogins";
import { MonthEndBillingModule } from "./Pages/MonthEndBillingModule";
import { StateReport } from "./Pages/StateReport";
import { RemovedQueue } from "./Pages/PolicyDashboardElements/RemovedQueue";
import { CustomerTransactions } from "./CustomerPanel/CustomerTransactions";
import AppDialogs from "./components/Dialog/AppDialogs";
import { ClientUsers } from "./Pages/CustomerUsers";
import { NotificationPreferences } from "./Pages/NotificationPreferences";
import { LicenseContactInformation } from "./Pages/LicenseContactInformation";
import TestPage from "./Pages/Test";
import NonPremiumEndorsements from "./Pages/NonPremiumEndorsementUpload";
import config, {
  applyFeatureFlagsFromApi,
  getBatchFilingReviewFeatureEnabled,
  getCreateDiligentSearchFormFeatureEnabled,
  getStateReportsFeatureEnabled,
  getSurplusLinesTaxEstimatorFeatureEnabled,
} from "./helper/config";
import NonPremiumEndorsement from "./Pages/NonPremiumEndorsementList";
import { ClientStateReports } from "./CustomerPanel/ClientStateReports";
import { YearToDateReport } from "./Pages/YearToDateReport";
import { AdminHomePage } from "./Pages/AdminHomePage";
import { AdminIWantTo } from "./Pages/AdminIWantTo";
import { SurplusLinesTaxEstimator } from "./Pages/SurplusLinesTaxEstimator";
import { MiscNotifications } from "./Pages/MiscNotifications";
import { RequestSignature } from "./Pages/RequestSignature";
import { SendStampedDocument } from "./Pages/SendStampedDocument";
import { ReportTag } from "./Pages/ReportTag";
import { AddReportTag } from "./components/AddEdit/AddReportTag";
import { DiligentSearchLibrary } from "./Pages/DiligentSearchLibrary";
import { BatchFilingReview } from "./Pages/BatchFilingReview";
import { ClientFilingDefaults } from "./Pages/ClientFilingDefaults";
import { CustomerInbox } from "./Pages/CustomerInbox";
import CustomerHomeLayout from "./components/Layout/CustomerHomeLayout";
import CustomerHomePage from "./Pages/CustomerHomePage";
import { MonthlyAccountPerformanceReport } from "./Pages/MonthlyAccountPerformanceReport";
import { CLIENT_HOME_ROLES, hasAnyRole, MONTHLY_ACCOUNT_PERFORMANCE_REPORT_ROLES } from "./helper/userRoles";
import { apiClient } from "./helper/api";
import FeatureFlagGate from "./components/common/FeatureFlagGate";

// import " /assets/dist/css/proximanova_regular.ttf"

LicenseInfo.setLicenseKey(MuiLicenseKey);

function App() {
  const { user, loading } = useAuth();
  console.log({ config })

console.log(window.location.pathname.includes("Demo"));
  const [sortModel, setSortModel] = useState<{ field: string, sort: string }[]>([]);
  const [featureFlagsRevision, setFeatureFlagsRefresh] = useState(0);
  const [featureFlagsReady, setFeatureFlagsReady] = useState(() => !user?.token);

  useEffect(() => {
    if (!user?.token) {
      setFeatureFlagsReady(true);
      return;
    }

    setFeatureFlagsReady(false);
    let isMounted = true;

    apiClient("/config/feature-flags", {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: `Bearer ${user.token}`,
      }),
    })
      .then((responseJson) => {
        if (!isMounted || !responseJson) return;
        applyFeatureFlagsFromApi(responseJson?.data);
      })
      .catch(() => {
        // Flags stay false when the endpoint is unavailable.
      })
      .finally(() => {
        if (!isMounted) return;
        setFeatureFlagsReady(true);
        setFeatureFlagsRefresh((value) => value + 1);
      });

    return () => {
      isMounted = false;
    };
  }, [user?.token]);

  const routes: RouteObject[] = [
    {
      // parent route component
      element: hasAnyRole(user?.userRoles, CLIENT_HOME_ROLES)
                ?
                  (
                    window.location.pathname.includes(AppRoutes.client.home) ?
                    <CustomerHomeLayout />:
                    <CustomerLayout />
                  )
                :
                  <Layout />,
      // child route components
      children: [
        {
          path: AppRoutes.home.base,
          element: (
            <PrivateRoute roles={['MISC Filer', 'MISC State Reporter', 'Super Admin']} currentUser={user} loading={loading}>
                <AdminHomePage />
            </PrivateRoute>
          ),
        },
        {
          path: AppRoutes.home.iWantTo,
          element: (
            <PrivateRoute roles={['MISC Filer', 'MISC State Reporter', 'Super Admin']} currentUser={user} loading={loading}>
                <AdminIWantTo />
            </PrivateRoute>
          ),
        },
        {
          path: AppRoutes.home.surplusLinesTaxEstimator,
          element: (
            <PrivateRoute roles={['MISC Filer', 'MISC State Reporter', 'Super Admin']} currentUser={user} loading={loading}>
              <FeatureFlagGate
                when={getSurplusLinesTaxEstimatorFeatureEnabled}
                redirectTo={AppRoutes.home.base}
                featureFlagsRevision={featureFlagsRevision}
                featureFlagsReady={featureFlagsReady}
              >
                <SurplusLinesTaxEstimator />
              </FeatureFlagGate>
            </PrivateRoute>
          ),
        },
        {
          path: AppRoutes.misc.notifications,
          element: (
            <PrivateRoute roles={['MISC Filer', 'MISC State Reporter', 'Super Admin']} currentUser={user} loading={loading}>
              <MiscNotifications />
            </PrivateRoute>
          ),
        },
        {
          path: AppRoutes.home.requestSignature,
          element: (
            <PrivateRoute roles={['MISC Filer', 'MISC State Reporter', 'Super Admin', 
                'Customer User', 'Client Admin', 'Client Processors', 'State Reporter'
              ]} currentUser={user} loading={loading}>
                <RequestSignature />
            </PrivateRoute>
          ),
        },
        {
          path: AppRoutes.home.sendStampedDocument,
          element: (
            <PrivateRoute roles={['MISC Filer', 'MISC State Reporter', 'Super Admin', 
              'Customer User', 'Client Admin', 'Client Processors', 'State Reporter'
            ]} currentUser={user} loading={loading}>
                <SendStampedDocument />
            </PrivateRoute>
          ),
        },
        {
          path: AppRoutes.home.reportTag,
          element: (
            <PrivateRoute roles={['MISC Filer', 'MISC State Reporter', 'Super Admin']} currentUser={user} loading={loading}>
                <ReportTag />
            </PrivateRoute>
          ),
        },
        {
          path: AppRoutes.home.diligentSearchLibrary,
          element: (
            <PrivateRoute roles={['MISC Filer', 'MISC State Reporter', 'Super Admin',
              'Client Admin', 'Diligent Search User'
            ]} currentUser={user} loading={loading} requireDiligentSearchUser>
                <DiligentSearchLibrary />
            </PrivateRoute>
          ),
        },
        {
          path: AppRoutes.client.home,
          element: (
            <PrivateRoute roles={[...CLIENT_HOME_ROLES]} currentUser={user} loading={loading}>
                <CustomerHomePage />
            </PrivateRoute>
          ),
        },
        {
          path: AppRoutes.client.surplusLinesTaxEstimator,
          element: (
            <PrivateRoute roles={[...CLIENT_HOME_ROLES]} currentUser={user} loading={loading}>
              <FeatureFlagGate
                when={getSurplusLinesTaxEstimatorFeatureEnabled}
                redirectTo={AppRoutes.client.home}
                featureFlagsRevision={featureFlagsRevision}
                featureFlagsReady={featureFlagsReady}
              >
                <SurplusLinesTaxEstimator />
              </FeatureFlagGate>
            </PrivateRoute>
          ),
        },
        {
          path: AppRoutes.client.base,
          element: (
            <PrivateRoute roles={['Client Admin', 'Client Processors']} currentUser={user} loading={loading}>
                <CustomerTransactions currentUser={user}/>
            </PrivateRoute>
          ),
        },
        {
          path: AppRoutes.client.stateReports,
          element: (
            <PrivateRoute roles={["Client Admin", "State Reporter"]} currentUser={user} loading={loading}>
              <FeatureFlagGate
                when={getStateReportsFeatureEnabled}
                redirectTo={
                  hasAnyRole(user?.userRoles, CLIENT_HOME_ROLES)
                    ? AppRoutes.client.home
                    : AppRoutes.home.base
                }
                featureFlagsRevision={featureFlagsRevision}
                featureFlagsReady={featureFlagsReady}
              >
                <ClientStateReports currentUser={user} />
              </FeatureFlagGate>
            </PrivateRoute>
          ),
        },
        {
          path: AppRoutes.inbox,
          element: (
            <PrivateRoute roles={['Client Admin', 'Client Processors', 'State Reporter', 'Diligent Search User', 'MISC Filer', 'MISC State Reporter']} currentUser={user} loading={loading}>
                <CustomerInbox />
            </PrivateRoute>
          ),
        },
        {
          path: AppRoutes.reporting.monthlyAccountPerformance,
          element: (
            <PrivateRoute roles={[...MONTHLY_ACCOUNT_PERFORMANCE_REPORT_ROLES]} currentUser={user} loading={loading}>
                <MonthlyAccountPerformanceReport />
            </PrivateRoute>
          ),
        },
        {
          path: AppRoutes.client.monthlyAccountPerformance,
          element: (
            <PrivateRoute roles={[...CLIENT_HOME_ROLES]} currentUser={user} loading={loading}>
                <MonthlyAccountPerformanceReport />
            </PrivateRoute>
          ),
        },
        {
          path: AppRoutes.root,
          element: (
            <PrivateRoute roles={["MISC Filer", "MISC State Reporter", "Super Admin"]} currentUser={user} loading={loading}>
              {user?.userRoles.split(",").includes("Super Admin") ||
              user?.userRoles.split(",").includes("MISC Filer") ? (
                <PolicyDashboard />
              ) : (
                <PolicyDashboard />
              )}
            </PrivateRoute>
          ),
        },

        {
          path: "/:LastTabId",
          element: (
            <PrivateRoute roles={["MISC Filer", "MISC State Reporter", "Super Admin"]} currentUser={user} loading={loading}>
              {user?.userRoles.split(",").includes("Super Admin") ||
              user?.userRoles.split(",").includes("MISC Filer") ? (
                <PolicyDashboard />
              ) : (
                <PolicyDashboard />
              )}
            </PrivateRoute>
          ),
        },

        {
          path: AppRoutes.filingQueue.removedQueue,
          element: (
            <PrivateRoute roles={["MISC Filer", "MISC State Reporter", "Super Admin"]} currentUser={user} loading={loading}>
                <RemovedQueue />
            </PrivateRoute>
          ),
        },

        {
          path: AppRoutes.reconciliationQueue,
          element: <Navigate to={`${AppRoutes.reconciliationQueue}/0`} replace />,
        },
        {
          path: `${AppRoutes.reconciliationQueue}/:LastTabId`,
          element: (
            <PrivateRoute roles={["MISC Filer", "MISC State Reporter", "Super Admin"]} currentUser={user} loading={loading}>
              <ReconciliationQueue />
            </PrivateRoute>
          ),
        },

        // SLIP+ Filing Review (A4) — opened per-row from the queue (CustomerPolicyId-keyed):
        //   /FilingQueue/Review/:state/:customerPolicyId   (state = "Tennessee" | "Florida")
        // Gated by EnableBatchFilingReview (independent of red-outline EnableFilingReviewUi).
        {
          path: `${AppRoutes.filingQueue.filingReview}/:state/:customerPolicyId`,
          element: (
            <PrivateRoute roles={["MISC Filer", "Super Admin"]} currentUser={user} loading={loading}>
              <FeatureFlagGate
                when={getBatchFilingReviewFeatureEnabled}
                redirectTo={AppRoutes.root}
                featureFlagsRevision={featureFlagsRevision}
                featureFlagsReady={featureFlagsReady}
              >
                <FilingReview />
              </FeatureFlagGate>
            </PrivateRoute>
          ),
        },

        {
          path: AppRoutes.filingQueue.batchReview,
          element: (
            <PrivateRoute roles={["Super Admin"]} currentUser={user} loading={loading}>
              <FeatureFlagGate
                when={getBatchFilingReviewFeatureEnabled}
                redirectTo={AppRoutes.root}
                featureFlagsRevision={featureFlagsRevision}
                featureFlagsReady={featureFlagsReady}
              >
                <BatchFilingReview />
              </FeatureFlagGate>
            </PrivateRoute>
          ),
        },

        {
          path: AppRoutes.filingQueue.clientDefaults,
          element: (
            <PrivateRoute roles={["MISC Filer", "Super Admin"]} currentUser={user} loading={loading}>
              <FeatureFlagGate
                when={getBatchFilingReviewFeatureEnabled}
                redirectTo={AppRoutes.root}
                featureFlagsReady={featureFlagsReady}
                featureFlagsRevision={featureFlagsRevision}
              >
                <ClientFilingDefaults />
              </FeatureFlagGate>
            </PrivateRoute>
          ),
        },

        {
          path: AppRoutes.policies,
          element: (
            <PrivateRoute roles={["MISC Filer", "MISC State Reporter", "Super Admin"]} currentUser={user} loading={loading}>
              <Policies />
            </PrivateRoute>
          ),
        },
        {
          path: AppRoutes.submissions,
          element: (
            <PrivateRoute roles={["MISC Filer", "MISC State Reporter", "Super Admin"]} currentUser={user} loading={loading}>
              <Submissions />
            </PrivateRoute>
          ),
        },
        {
          path: `${AppRoutes.policy}/:batchId`,
          element: (
            <PrivateRoute roles={["MISC Filer", "MISC State Reporter", "Super Admin"]} currentUser={user} loading={loading}>
              <Policy />
            </PrivateRoute>
          ),
        },


        {
          path: `${AppRoutes.transaction}/:policyid/:customerpolicyid`,
          element: (
            <PrivateRoute roles={["MISC Filer", "MISC State Reporter", "Super Admin"]} currentUser={user} loading={loading}>
              <Transaction />
            </PrivateRoute>
          ),
        },

        // {
        //   path: "/Transaction/:policyid",
        //   element: (
        //     <PrivateRoute roles={["MISC Filer", "MISC State Reporter", "Super Admin"]} currentUser={user} loading={loading}>
        //       <Transaction />
        //     </PrivateRoute>
        //   ),
        // },
        {
          path: AppRoutes.admin.taxesAndFees,
          element: (
            <PrivateRoute roles={["Super Admin", "MISC Filer"]} currentUser={user} loading={loading}>
              <TaxesAndFees />
            </PrivateRoute>
          ),
        },


        {
          path: AppRoutes.admin.insuranceCompany,
          element: (
            <PrivateRoute roles={["Super Admin", "MISC Filer"]} currentUser={user} loading={loading}>
              <InsuranceComapny />
            </PrivateRoute>
          ),
        },

        {
          path: AppRoutes.admin.users,
          element: (
            <PrivateRoute roles={["MISC Filer", "MISC State Reporter", "Super Admin"]} currentUser={user} loading={loading}>
              <Users />
            </PrivateRoute>
          ),
        },
        ...([
          {
            path: AppRoutes.admin.clientUsers,
            element: (
              // <PrivateRoute roles={["MISC Filer", "MISC State Reporter", "Super Admin"]} currentUser={user} loading={loading}>
              //   <Users />
  
              <PrivateRoute roles={["MISC Filer", "MISC State Reporter", "Super Admin","Customer User"]} currentUser={user} loading={loading}>
                <ClientUsers />
              </PrivateRoute>
            ),
          },
  
        ]),
        {
          path: AppRoutes.client.clientUsers,
          element: (
            // <PrivateRoute roles={["MISC Filer", "MISC State Reporter", "Super Admin"]} currentUser={user} loading={loading}>
            //   <Users />

            <PrivateRoute roles={["Client Admin"]} currentUser={user} loading={loading}>
              <ClientUsers />
            </PrivateRoute>
          ),
        },
        {
          path: AppRoutes.client.notificationPreferences,
          element: (
            <PrivateRoute roles={[...CLIENT_HOME_ROLES]} currentUser={user} loading={loading}>
              <NotificationPreferences />
            </PrivateRoute>
          ),
        },
        {
          path: AppRoutes.client.nonPremiumEndorsements,
          element: (
            <PrivateRoute roles={["Client Admin"]} currentUser={user} loading={loading}>
              <NonPremiumEndorsements sortModel={sortModel} setSortModel={setSortModel} />
            </PrivateRoute>
          ),
        },
        {
          path: `${AppRoutes.document}/:transactionID`,
          element: (
            <PrivateRoute roles={["MISC Filer", "MISC State Reporter", "Super Admin"]} currentUser={user} loading={loading}>
              <TransactionDetails />
            </PrivateRoute>
          ),
        },
        {
          path: `${AppRoutes.createCustomerPolicy}/:CustomerPolicyId`,
          element: (
            <PrivateRoute roles={["MISC Filer", "MISC State Reporter", "Super Admin"]} currentUser={user} loading={loading}>
              <CreateCustomerPolicy />
            </PrivateRoute>
          ),
        },

        {
          path: AppRoutes.newSubmission,
          element: (
            <PrivateRoute roles={["MISC Filer", "MISC State Reporter", "Super Admin"]} currentUser={user} loading={loading}>
              <CreateNewSubmission />
            </PrivateRoute>
          ),
        },
        {
          path: AppRoutes.customerPolicy,
          element: (
            <PrivateRoute roles={["MISC Filer", "MISC State Reporter", "Super Admin"]} currentUser={user} loading={loading}>
              <CustomerPolicy />
            </PrivateRoute>
          ),
        },

        {
          path: `${AppRoutes.addEditStateStamps}/:statesStampsListsId`,
          element: (
            <PrivateRoute roles={["Super Admin", "MISC Filer"]} currentUser={user} loading={loading} >
              <AddEditStateStamps />
            </PrivateRoute>
          ),
        },

        {
          path: AppRoutes.stateLogins,
          element: (
            <PrivateRoute roles={["MISC Filer", "MISC State Reporter", "Super Admin"]} currentUser={user} loading={loading}>
              <StateLogins />
            </PrivateRoute>
          ),
        },



        {
          path: AppRoutes.admin.statesZeroFilingRule,
          element: (
            <PrivateRoute roles={["Super Admin", "MISC Filer"]} currentUser={user} loading={loading}>
              <StatesZeroFilingRule />
            </PrivateRoute>
          ),
        },
        {
          path: `${AppRoutes.customerPolicyDocumentData}/:custPolicyId`,
          element: (
            <PrivateRoute roles={["MISC Filer", "MISC State Reporter", "Super Admin"]} currentUser={user} loading={loading}>
              <CustomerPolicyDocumentData />
            </PrivateRoute>
          ),
        },
        {
          path: `${AppRoutes.fmFlagReview}/:type`,
          element: (
            <PrivateRoute roles={["Super Admin", "Outsource Staff", "MISC Filer"]} currentUser={user} loading={loading}>
              <FMFlagReview />
            </PrivateRoute>
          ),
        },
        {
          path: AppRoutes.partners,
          element: (
            <PrivateRoute roles={["Super Admin", "MISC Filer", "Customer Admin"]} currentUser={user} loading={loading}>
              <Partners />
            </PrivateRoute>
          ),
        },

        {
          path: `${AppRoutes.userPartners}/:partnersId`,
          element: (
            <PrivateRoute roles={["Super Admin", "MISC Filer"]} currentUser={user} loading={loading}>
              <PartnerUsers />
            </PrivateRoute>
          ),
        },
        {
          path: "/Admin/StatesZeroFilingRule",
          element: (
            <PrivateRoute roles={["Super Admin", "MISC Filer"]} currentUser={user} loading={loading}>
              <StatesZeroFilingRule />
            </PrivateRoute>
          ),
        },
        {
          path: "/CustomerPolicyDocumentData/:custPolicyId",
          element: (
            <PrivateRoute roles={["MISC Filer", "MISC State Reporter", "Super Admin"]} currentUser={user} loading={loading}>
              <CustomerPolicyDocumentData />
            </PrivateRoute>
          ),
        },
        {
          path: "/FMFlagReview/:type",
          element: (
            <PrivateRoute roles={["Super Admin", "Outsource Staff", "MISC Filer"]} currentUser={user} loading={loading}>
              <FMFlagReview />
            </PrivateRoute>
          ),
        },
        {
          path: "/AddEditPartners/:partnersId",
          element: (
            <PrivateRoute roles={["Super Admin", "MISC Filer", "Customer Admin"]} currentUser={user} loading={loading}>
              <AddEditPartners />
            </PrivateRoute>
          ),
        },
        {
          path: "/UserPartners/:partnersId",
          element: (
            <PrivateRoute roles={["Super Admin", "MISC Filer"]} currentUser={user} loading={loading}>
              <PartnerUsers />
            </PrivateRoute>
          ),
        },
        {
          path: AppRoutes.admin.manualStateSubmissionSchedule,
          element: (
            <PrivateRoute roles={["Super Admin", "Outsource Staff", "MISC Filer"]} currentUser={user} loading={loading}>
              <PolicyFilingsSchedule />
            </PrivateRoute>
          ),
        },
        {
          path: AppRoutes.admin.carrierManagement,
          element: (
            <PrivateRoute roles={["Super Admin", "MISC Filer"]} currentUser={user} loading={loading}>
              <CarrierManagement />
            </PrivateRoute>
          ),
        },
        {
          path: AppRoutes.admin.sendClientPortalUpdate,
          element: (
            <PrivateRoute roles={["Super Admin", "MISC Filer"]} currentUser={user} loading={loading}>
              <SendClientPortalUpdate />
            </PrivateRoute>
          ),
        },
        {
          path: AppRoutes.admin.clientFeeSchedule,
          element: (
            <PrivateRoute roles={["Super Admin", "MISC Filer"]} currentUser={user} loading={loading}>
              <PartnerFeesT />
            </PrivateRoute>
          ),
        },
        {
          path: AppRoutes.admin.taxScheduleByJurisdiction,
          element: (
            <PrivateRoute roles={["Super Admin", "MISC Filer"]} currentUser={user} loading={loading}>
              <TaxScheduleByJurisdiction />
            </PrivateRoute>
          ),
        },
        {
          path: `${AppRoutes.admin.filingSchedule}/:type`,
          element: (
            <PrivateRoute roles={["Super Admin", "MISC Filer"]} currentUser={user} loading={loading}>
              <TaxesAndFeesFilingSchedule />
            </PrivateRoute>
          ),
        },
        {
          path: AppRoutes.admin.messageTemplates,
          element: (
            <PrivateRoute roles={["Super Admin", "MISC Filer"]} currentUser={user} loading={loading}>
              <MessageTemplatesAdmin />
            </PrivateRoute>
          ),
        },
        // DocumentType route removed
        {
          path: `${AppRoutes.admin.editCASLaSubmissionData}/:CustomerPolicyId`,
          element: (
            <PrivateRoute roles={["Super Admin", "MISC Filer"]} currentUser={user} loading={loading} >
              <AddEditCASlaJsonData />
            </PrivateRoute>
          ),
        },
        {
          path: `${AppRoutes.admin.addEditCustomerPolicyDetails}/:CustomerPolicyId`,
          element: (
            <PrivateRoute roles={["Super Admin", "MISC Filer",  "MISC State Reporter"]} currentUser={user} loading={loading}>
              <AddEditCustomerPolicyDetails />
            </PrivateRoute>
          ),
        },
        {
          path: AppRoutes.admin.submissionData,
          element: (
            <PrivateRoute roles={["Super Admin", "MISC Filer"]} currentUser={user} loading={loading}>
              <SubmissionData_SD />
            </PrivateRoute>
          ),
        },

        // UserMappingRequestLog route removed
        {
          path: `${AppRoutes.licenseMatrix}/`,
          element: (
            <PrivateRoute roles={["MISC Filer", "MISC State Reporter", "Super Admin"]} currentUser={user} loading={loading}>
              <LicenseContactInformation/>
            </PrivateRoute>
          ),
        },
        { path: `${AppRoutes.resetPassword}/:UserHash`, element: <ResetPassword /> },
        { path: `${AppRoutes.forgotPassword}/:token`, element: <ResetPassword /> },
        { path: `${AppRoutes.lateFilingForm}/:UserHash`, element: <LateFilingForm /> },
        { path: AppRoutes.thankYou, element: <Thankyou /> },

        {
          path: `${AppRoutes.correctedDocumentResubmission}/:CustomerPolicyId`,
          element: <ResubmitSingleDocumentNew />,
        },

        // AddStateFlags route removed

        { path: AppRoutes.notFound, element: <PageNotFound /> },

        {
          path: AppRoutes.admin.reportModule,
          element: (
            <PrivateRoute roles={["Super Admin", "MISC Filer"]} currentUser={user} loading={loading}>
              <ReportModule />
            </PrivateRoute>
          ),
        },
        {
          path: AppRoutes.reporting.diligentSearch,
          element: (
            <PrivateRoute roles={["Super Admin", "MISC Filer", "MISC State Reporter"]} currentUser={user} loading={loading}>
              <DiligentSearch />
            </PrivateRoute>
          ),
        },

        {
          path: AppRoutes.reporting.stateReport,
          element: (
            <PrivateRoute roles={["Super Admin", "MISC Filer", "MISC State Reporter"]} currentUser={user} loading={loading}>
              <FeatureFlagGate
                when={getStateReportsFeatureEnabled}
                redirectTo={
                  hasAnyRole(user?.userRoles, CLIENT_HOME_ROLES)
                    ? AppRoutes.client.home
                    : AppRoutes.home.base
                }
                featureFlagsRevision={featureFlagsRevision}
                featureFlagsReady={featureFlagsReady}
              >
                <StateReport />
              </FeatureFlagGate>
            </PrivateRoute>
          ),
        },
        {
          path: "/reporting/StateReport",
          element: (
            <PrivateRoute roles={["Super Admin", "MISC Filer", "MISC State Reporter"]} currentUser={user} loading={loading}>
              <FeatureFlagGate
                when={getStateReportsFeatureEnabled}
                redirectTo={
                  hasAnyRole(user?.userRoles, CLIENT_HOME_ROLES)
                    ? AppRoutes.client.home
                    : AppRoutes.home.base
                }
                featureFlagsRevision={featureFlagsRevision}
                featureFlagsReady={featureFlagsReady}
              >
                <StateReport />
              </FeatureFlagGate>
            </PrivateRoute>
          ),
        },
        {
          path: AppRoutes.reporting.openTaxReport,
          element: (
            <PrivateRoute roles={["Super Admin", "MISC Filer"]} currentUser={user} loading={loading}>
              <OpenTaxReport />
            </PrivateRoute>
          ),
        },
        {
          path: AppRoutes.reporting.yearToDate,
          element: (
            <PrivateRoute roles={["Super Admin", "MISC Filer", "MISC State Reporter"]} currentUser={user} loading={loading}>
              <YearToDateReport />
            </PrivateRoute>
          ),
        },
        {
          path: AppRoutes.customerOpenTaxReport,
          element: (
            <PrivateRoute roles={["Customer Admin"]} currentUser={user} loading={loading}>
              <CustomerOpenTaxReport />
            </PrivateRoute>
          ),
        },
        {
          path: AppRoutes.billing.monthEndBillingModule,
          element: (
            <PrivateRoute roles={["Super Admin", "MISC Filer"]} currentUser={user} loading={loading}>
              <MonthEndBillingModule/>
            </PrivateRoute>
          ),
        },

        {
          path: AppRoutes.billing.stateReportsBilling,
          element: (
            <PrivateRoute roles={["Super Admin", "MISC Filer"]} currentUser={user} loading={loading}>
              <FeatureFlagGate
                when={getStateReportsFeatureEnabled}
                redirectTo={
                  hasAnyRole(user?.userRoles, CLIENT_HOME_ROLES)
                    ? AppRoutes.client.home
                    : AppRoutes.home.base
                }
                featureFlagsRevision={featureFlagsRevision}
                featureFlagsReady={featureFlagsReady}
              >
                <StateReportsBilling />
              </FeatureFlagGate>
            </PrivateRoute>
          ),
        },
        {
          path: AppRoutes.reporting.emailReportModule,
          element: (
            <PrivateRoute roles={["Super Admin", "MISC Filer"]} currentUser={user} loading={loading}>
              <EmailReportModule />
            </PrivateRoute>
          ),
        },
        {
          path: AppRoutes.filingQueue.nonPremiumEndorsement,
          element: (
            <PrivateRoute roles={["Super Admin", "MISC Filer", "MISC State Reporter"]} currentUser={user} loading={loading}>
              <NonPremiumEndorsement/>
            </PrivateRoute>
          ),
        },

        {
          path: `${AppRoutes.reporting.emailReportModuleDetails}/:emailReportId`,
          element: (
            <PrivateRoute roles={["Super Admin", "MISC Filer"]} currentUser={user} loading={loading}>
              <EmailReportModuleDetails />
            </PrivateRoute>
          ),
        },
      ],
    },
  
    { path: AppRoutes.login, element: <LoginPage /> },
    
    { path: AppRoutes.comingSoon, element: <ComingSoon /> },

    // { path: "/Customer/Login", element: <CustomerLoginPage /> },

    { path: AppRoutes.test, element: <TestPage /> },
  ];

  const content = useRoutes(routes);
  return (
    <>
      <AppDialogs />
      {content}
    </>);
}

export default App;
